import React, { useState } from "react";
import logo from "../../../images/logo_white1.png";
import "./login.css";
import "./host.css";
import { useNavigate } from "react-router-dom";
import { hostLogin } from "../../../api/host.api";

import { useDispatch } from "react-redux";
import { setAuth } from "../../../store/auth/AuthSlice";

const HostLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const data = await hostLogin({ username, password }); // ✅ use helper
      console.log("🚀 ~ handleSubmit ~ data:", data)

      // Save to localStorage
      localStorage.setItem("hostloginmail", data.companyName);
      localStorage.setItem("companyId", data.companyId);
      localStorage.setItem("hostDetails", JSON.stringify(data));
      if (data.token) {
        localStorage.setItem("token", data.token);
      }

      // Update Redux state
      dispatch(setAuth({
        _id: data._id,
        email: data.primaryEmail,
        fullName: data.companyName,
        userType: ['host'],
        isAuthenticated: true
      }));

      navigate("/host/dashboard");
    } catch (err) {
      console.error("Host login failed:", err);
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="host-login-bg d-flex flex-column min-vh-100 justify-content-center align-items-center position-relative">
      <div
        className="d-flex flex-column align-items-center"
        style={{ maxWidth: 420, width: "100%" }}
      >
        <div className="text-center w-100">
          <img
            src={logo}
            alt="somadome logo"
            className="mb-3"
            style={{ maxWidth: 300, width: "50vw", minWidth: 100 }}
          />
        </div>
        <form
          onSubmit={handleSubmit}
          className="w-75 d-flex flex-column align-items-center"
        >
          <div className="mb-3 w-100">
            <label
              className="lato-medium-20 text-white mb-2 text-center w-100"
              htmlFor="username"
            >
              User name
            </label>
            <input
              type="text"
              className="form-control bg-white bg-opacity-75 border-0 rounded-1 py-4-5 px-4 lato-medium-16 w-100"
              id="username"
              placeholder="user name"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="mb-4 w-100">
            <label
              className="lato-medium-20 text-white mb-2 text-center w-100"
              htmlFor="password"
            >
              Password
            </label>
            <input
              type="password"
              className="form-control bg-white bg-opacity-75 border-0 rounded-1 py-4-5 px-4 lato-medium-16 w-100"
              id="password"
              placeholder="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && (
            <div className="text-white mb-2 w-100 text-center">{error}</div>
          )}
          <button
            type="submit"
            className="btn lato-bold-25u w-100 py-3 mt-5"
            style={{
              background: "#ff1be6",
              color: "#fff",
              border: "none",
              fontWeight: 700,
              fontSize: 20,
              textTransform: "uppercase",
              letterSpacing: 0,
            }}
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
      <div
        className="position-absolute w-100 text-center"
        style={{ bottom: 32 }}
      >
        <span
          className="lato-bold-20 text-white fst-italic"
          style={{ opacity: 0.8, fontSize: 18 }}
        >
          Trouble signing in?
        </span>
      </div>
    </div>
  );
};

export default HostLogin;
